var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProtectOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1,.cls-2{stroke:#009fe3;}.cls-1{stroke-width:3px;}.cls-2{fill:#009fe3;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_shield_02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_812",
    "data-name": "Grupo 812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_390",
    "data-name": "Trazado 390",
    className: "cls-1",
    d: "M49.43,11.86A35.66,35.66,0,0,1,30,6.1a36.28,36.28,0,0,1-19.72,5.76V34.34c0,10.42,16,19.56,19.72,19.56s19.72-9.14,19.72-19.56V11.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_393",
    "data-name": "Trazado 393",
    className: "cls-2",
    d: "M43,18A23.7,23.7,0,0,1,30.1,14.17,24.11,24.11,0,0,1,17,18V32.93c0,6.92,10.61,13,13.1,13s13.1-6.07,13.1-13V18Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -0.22,
    y: 0.04,
    width: 60,
    height: 60
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtectOn);
export default __webpack_public_path__ + "static/media/icon_protect_on.3f9cbc552bac988aab3f8bc05a720707.svg";
export { ForwardRef as ReactComponent };